import {
  Component,
  OnInit,
  ViewEncapsulation,
  HostListener
}                            from '@angular/core';

import { LanguageService }   from '../../../core/services/language.service';
import { ScreenSizeService } from '../../../core/services/screen-size.service';
import { EventsService } from "../../../core/services/events.service";
import {LANGUAGE_WAS_CHANGED} from "../../../app.constants";

@Component({
  selector: 'lang-nav',
  templateUrl: './lang-nav.component.html',
  styleUrls: ['./lang-nav.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LangNavComponent implements OnInit {
  languages = [];
  selected;
  optionsIsVisible = false;

  constructor (
    private langService: LanguageService,
    private screenSizeService: ScreenSizeService,
    private eventBus: EventsService
  ) {}

  ngOnInit () {
    this.languages = this.langService.getAvailableLanguages();
    this.languages.forEach(lang => {
      if (lang.active) {
        this.selected = lang;
      }
    })
  }

  @HostListener('document:click') closeOptions(){
    this.optionsIsVisible = false;
  }

  changeLanguage(lang) {
    this.optionsIsVisible = !this.optionsIsVisible;
    this.selected = lang;
    this.eventBus.trigger(LANGUAGE_WAS_CHANGED, lang.key);
  }

  showOptions($event) {
    $event.stopPropagation();
    this.optionsIsVisible = !this.optionsIsVisible;
  }

  getViewName (lang) {
    const isShort = this.screenSizeService.isLarge();
    return isShort ? lang.shortName : lang.name;
  }
}


// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/moddules/header/translate/lang-nav.component.ts